import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {DonneesChampModel} from '../parametre-donnees.types';
import {ParametreDonneesStateService} from '../parametre-donnees-state.service';

@Component({
  selector: 'app-parametre-donnees-api-tab',
  templateUrl: './parametre-donnees-api-tab.component.html',
  styleUrls: ['./parametre-donnees-api-tab.component.scss']
})
export class ParametreDonneesApiTabComponent implements OnChanges {
  @Input() moduleKey = 'produits';

  champs: DonneesChampModel[] = [];

  constructor(
    private readonly state: ParametreDonneesStateService,
    private readonly toastr: ToastrService
  ) {}

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['moduleKey']) {
      this.champs = this.state.getChamps(this.moduleKey);
    }
  }

  save(): void {
    this.state.saveChampsBulkApi(this.moduleKey, this.champs).subscribe({
      next: () => {
        this.champs = this.state.getChamps(this.moduleKey);
        this.toastr.success('Configuration API enregistrée.', 'Succès');
      },
      error: () => {}
    });
  }

  trackById(_: number, c: DonneesChampModel): string {
    return c.id;
  }
}
